import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	available: {
		id: 'ui.screen.pagesGraphs.content.available',
	},
	empty: {
		id: 'ui.screen.pagesGraphs.content.empty',
	},
	missing: {
		id: 'ui.screen.pagesGraphs.content.missing',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
	field: string;
};



const ContentPresenceChart: React.FC<Props> = (props) => {
	const {
		data,
		field,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: 'available',
			label: intl.formatMessage(messages.available),
			color: '#42CC67',
		},
		{
			value: 'empty',
			label: intl.formatMessage(messages.empty),
			color: '#FF9830',
		},
		{
			value: 'missing',
			label: intl.formatMessage(messages.missing),
			color: '#FF5959',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			name={field}
			percentageFactor={100}
		/>
	);
};



export default React.memo(ContentPresenceChart);
